import { urlRegex } from "./regexPatterns/UrlRegex";

export const formatStringWithLink = (value: string) => {
  const links = value.match(urlRegex) || [];
  const parts = value.split(urlRegex);
  const messagesArray: string[] = [];

  parts.forEach((part, index) => {
    const trimmedPart = part.trim();
    const link = links[index];
    if (trimmedPart && !urlRegex.test(trimmedPart)) {
      messagesArray.push(trimmedPart);
    }
    if (typeof link === "string") {
      messagesArray.push(link);
    }
  });

  return messagesArray;
};
